import { EditButton, List, TextField, useTable } from '@refinedev/antd';
import { IGroup } from 'interfaces/epimetheus/groups';
import { ILibrary } from 'interfaces/libraries';
import { Space, Table } from 'antd';
import { useCan, useOne } from '@refinedev/core';
import { useParams } from 'react-router-dom';

export const TagGroupList = () => {
  const { libraryId } = useParams();
  const { data: canList } = useCan({
    resource: 'library_tag_groups',
    action: 'list'
  });
  const hasListPermission = !!canList?.can;

  const { tableProps } = useTable<IGroup>({
    resource: `prometheus/v2/libraries/${libraryId}/tag_groups`,
    queryOptions: {
      enabled: !!libraryId && hasListPermission
    },
    meta: {
      libraryId
    }
  });

  const { data } = useOne<ILibrary>({
    resource: 'prometheus/v2/libraries',
    id: libraryId!,
    queryOptions: {
      enabled: !!libraryId && hasListPermission
    }
  });

  if (!hasListPermission) {
    return null;
  }

  return (
    <List title={`Tags da biblioteca ${data?.data.name}`}>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="id"
          key="id"
          title="Id"
          render={value => <TextField value={value} />}
        />

        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />

        <Table.Column<IGroup>
          title="Ações"
          dataIndex="actions"
          render={(_, record) => {
            return (
              <Space>
                <EditButton
                  hideText
                  size="small"
                  resource="library_tag_groups"
                  recordItemId={record.id}
                  meta={{ libraryId }}
                  accessControl={{ hideIfUnauthorized: true }}
                />
              </Space>
            );
          }}
        />
      </Table>
    </List>
  );
};
